import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currency'
})
export class CurrencyPipe implements PipeTransform {

  transform(value: any): any {
    if(value == null || value == "") return "0,00";
    if(typeof value === 'number') value = value.toFixed(2);
    else value = value.replace(",", ".");
    var output = parseFloat(value).toFixed(2).replace(".", ",");
    return output;
  }

}
